const o = {
  name: "HongKong",
  dimensions: { width: 20, height: 21 },
  content: `
    <g>
      <path d="M1.03003 14.5875L3.97003 19.5875H17.97L18.97 15.4775H7.83003L6.79003 14.5875H1.03003Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M10.97 14.5875V1.58752H7.96997C7.96997 1.58752 4.96997 4.27752 4.96997 7.58752C4.96997 10.8975 6.05997 11.4975 6.05997 11.4975L10.86 11.4775" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17.97 15.5875L17.95 6.5675L14.97 6.5875C14.97 6.5875 14.02 8.83751 14.02 10.8875C14.02 12.5875 14.97 12.5875 14.97 12.5875H17.97" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.96997 5.58752H11.97" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.96997 8.58752H11.97" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  o as HongKong
};
